import React from "react";
import * as yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Controller, useForm} from "react-hook-form";
import StationChooserForSite from "../../stations/StationChooserForSite";
import Button from "@material-ui/core/Button";
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import PressPalletIcon from "../PressPalletIcon";
import {onFinishPallet, printManifest} from "./PalletBuilderController";
import {yupResolver} from "@hookform/resolvers";

const LAST_STATION_KEY = "FinishPalletLastStationId";

const validationPrint = yup.object({
    stationId: yup.string().required()
});


const BuildPalletUIPrintManifest = ({currentState, sendEvent}) => {

    const [saving, setSaving] = React.useState(false);
    const [printing, setPrinting] = React.useState(false);

    const pallet = currentState.context.pallet;

    const {register, handleSubmit, errors, setValue, control} = useForm({
        resolver: yupResolver(validationPrint)
    });

    const contentItems = [];
    contentItems.push(
        (
            <StationChooserForSite label='Print Manifest On' fullWidth={true} name="stationId"/>

        )
    );

    const buttonItems = [];
    buttonItems.push((
        <Button type="submit" variant="contained" color="primary" fullWidth={true} disabled={saving || printing}>
            Print Manifest
        </Button>));

    const title = 'Print Manifest';
    const description = pallet.id;


    const onSubmit = async data => {
        sendEvent("CONFIRM", data);
    };

    const submitForm = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={title}
                           description={description} buttons={buttonItems}
                           content={contentItems}/>

        </form>
    );


    return submitForm;


}

export default BuildPalletUIPrintManifest;